import { useMutation } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { ApiError, InferFetchData, throwOnError } from 'api/helpers';

async function resetTotpSecret(apiClient: ApiClient, accountId: number) {
  return apiClient.DELETE('/op/v2/account/{id}/totp-secret', {
    params: { path: { id: accountId } },
  });
}

export default function useResetTotpSecretMutation(accountId: number) {
  const apiClient = useApiClient();

  return useMutation<InferFetchData<typeof resetTotpSecret>, ApiError, void>({
    mutationKey: ['ResetTotpSecret', accountId],
    mutationFn: () => throwOnError(resetTotpSecret(apiClient, accountId)),
  });
}
